import { MovieOpenOffOutlineIcon } from './MovieOpenOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id AF946982-D5F6-4E17-8B0A-B091A873F86E
 * name movie-open-off-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-off-outline.svg
 * tags
 * - Video / Movie 
 */
export const SlateOpenOffOutlineIcon = MovieOpenOffOutlineIcon;
export default SlateOpenOffOutlineIcon